import {inlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {UserErrorsFactory} from '../../user/Errors/factory.js'
import UserServicesFactory from '../../user/Services/factory.js'
import {DraftRepositoriesFactory} from '../Repositories/factory.js'

export class UploadPhotoDraftAdPublisherUseCase extends UseCase {
  #getCurrentUserService
  #httpRepository
  #userNotLoggedInUserError

  constructor({config} = {}) {
    super()
    this.#getCurrentUserService = UserServicesFactory.getCurrentUserService({config})
    this.#httpRepository = DraftRepositoriesFactory.hTTPDraftRepository({config})
    this.#userNotLoggedInUserError = UserErrorsFactory.userNotLoggedInUserError
  }

  static create({config}) {
    return new UploadPhotoDraftAdPublisherUseCase({config})
  }

  @inlineError
  async execute({adId, image}) {
    const userEntity = await this.#getCurrentUserService.execute()

    if (!userEntity) {
      return Promise.reject(
        this.#userNotLoggedInUserError({
          message: '[UploadPhotoDraftAdPublisherUseCase#execute] User not logged in'
        })
      )
    }

    const [error, uploadPhotoResponseVO] = await this.#httpRepository.uploadPhotoDraft({
      adId,
      image,
      userEntity
    })

    if (error) return Promise.reject(error)
    return uploadPhotoResponseVO.toJSON()
  }
}

export const factory = UploadPhotoDraftAdPublisherUseCase.create
